
import { csrfToken } from '@/js/_common';
import { setAlert } from '@/js/_components/head-alert';
import { showConfirmModal } from '@/js/_components/parts/confirm-modal';

const main = () => {
    if (document.querySelector('#page-user-plan-index') == null) return

    const cancelAlertKey = 'user_plan_cancel_success'
    if (sessionStorage.getItem(cancelAlertKey)) {
        sessionStorage.removeItem(cancelAlertKey)
        setAlert('解約しました。', 'success')
    }

    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('checkout') === 'success') {
        setAlert('申し込みが完了しました。', 'success')
        urlParams.delete('checkout')
        const newQuery = urlParams.toString()
        const newUrl = newQuery ? `${window.location.pathname}?${newQuery}` : window.location.pathname
        window.history.replaceState({}, '', newUrl)
    }

    const button = document.querySelector('.button-contract-subscription')
    const runCheckout = async () => {
        if (!button || button.disabled) return
        button.disabled = true

        try {
            const checkoutUrl = button.dataset.checkoutUrl
            const resp = await fetch(checkoutUrl, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            })

            if (!resp.ok) {
                const errorText = await resp.text()
                console.error('Checkout error:', errorText)
                setAlert('サブスク契約の開始に失敗しました。', 'error')
                button.disabled = false
                return
            }

            const data = await resp.json()
            if (data.url) {
                window.location.href = data.url
            } else {
                setAlert('サブスク契約の開始に失敗しました。', 'error')
                button.disabled = false
            }
        } catch (e) {
            console.error(e)
            setAlert('サブスク契約の開始に失敗しました。', 'error')
            button.disabled = false
        }
    }

    if (button) {
        button.addEventListener('click', () => {
            showConfirmModal({
                type: 'confirm',
                message: 'プレミアムプランに切り替えます。',
                confirmMessage: 'よろしいですか？(※このあと決済画面に移動します。)',
                confirmText: 'このプランに変更',
                cancelText: 'キャンセルして閉じる',
                onConfirm: runCheckout,
            })
        })
    }

    const cancelButton = document.querySelector('.button-cancel-subscription')
    const runCancel = async () => {
        if (!cancelButton || cancelButton.disabled) return
        cancelButton.disabled = true

        try {
            const cancelUrl = cancelButton.dataset.cancelUrl
            const resp = await fetch(cancelUrl, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            })

            if (!resp.ok) {
                const errorText = await resp.text()
                console.error('Cancel error:', errorText)
                setAlert('解約に失敗しました。', 'error')
                cancelButton.disabled = false
                return
            }

            sessionStorage.setItem(cancelAlertKey, '1')
            window.location.reload()
        } catch (e) {
            console.error(e)
            setAlert('解約に失敗しました。', 'error')
            cancelButton.disabled = false
        }
    }

    if (cancelButton) {
        cancelButton.addEventListener('click', () => {
            showConfirmModal({
                type: 'confirm',
                message: 'プレミアムプランを解約してスタンダードプランに戻します。',
                confirmMessage: 'よろしいですか？',
                confirmText: 'このプランに変更',
                cancelText: 'キャンセルして閉じる',
                onConfirm: runCancel,
            })
        })
    }
}

export default main
